module.exports = __webpack_public_path__ + "static/media/016_iOS - 18 - COST & COVERAGE.1b5f530b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/016_iOS - 18 - COST & COVERAGE.png
// module id = 513
// module chunks = 0